import { Reveal } from "./Reveal";

const POINTS = [
  { title: "Person of Goan Origin", text: "Strict implementation of the definition under the Goan Succession, Special Notaries and Inventory Proceeding Act, 2012 — with name-change provisions restricted to those to whom the Act applies." },
  { title: "Land, Water, Forest & Resources", text: "Protection and conservation of Goa's natural wealth." },
  { title: "Scrap Section 39A of TCP Act", text: "Abolish the destructive provision that converts Goa's green zones into concrete." },
  { title: "Law & Order", text: "Modern methods and clear responsibilities to keep every Goan safe." },
  { title: "Goan Businesses & Industries", text: "Support and hand-holding, along with employment, training and job identification for Goan youth." },
  { title: "Tourism Stakeholders", text: "Workable solutions that put tourism back in the hands of local stakeholders." },
  { title: "Village-Level Environment Protection", text: "Through Gram Sabhas — adopting the 73rd & 74th amendments of the Panchayat Raj Act, 1994." },
  { title: "Water & Electricity Reforms", text: "Reforms in conservation, supply and billing for every household." },
  { title: "No Defectors, No Defection", text: "An unbreakable pledge — your vote will never be traded." },
  { title: "Tender Process Reforms", text: "Transparent reforms in services, supply and work contracts across all departments." },
  { title: "Revisit All Policies", text: "Review every policy of the past 10 years and change what fails the people." },
];

export const About = () => (
  <section id="about" className="relative py-28 sec-about overflow-hidden" data-testid="about-section">
    <div className="absolute -top-32 -right-32 w-[560px] h-[560px] rounded-full bg-yellow-400/[0.07] blur-[150px]" />
    <div className="absolute bottom-0 -left-40 w-[480px] h-[480px] rounded-full bg-yellow-400/[0.04] blur-[140px]" />

    <div className="max-w-7xl mx-auto px-5 lg:px-10 relative">
      <div className="grid lg:grid-cols-[1.2fr_1fr] gap-10 lg:gap-16 items-center">
        <Reveal>
          <p className="eyebrow mb-4">// Who We Are</p>
          <h2 className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
            About <span className="text-yellow-400">RGP</span>
          </h2>
          <p className="mt-6 text-zinc-400 leading-relaxed max-w-xl">
            The Revolutionary Goans Party (RGP) is committed to building a stronger,
            self-reliant and sustainable Goa — a Goa that is prosperous, inclusive and
            rooted in its identity.
          </p>
          <p className="mt-4 text-zinc-400 leading-relaxed max-w-xl">
            Born from the villages, vaddos and communities of Goa, RGP believes that
            the people of Goa must have a meaningful voice in shaping the future of
            their land, communities and way of life.
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="relative bg-yellow-400 text-black p-8 lg:p-10 overflow-hidden shadow-[0_24px_70px_rgba(250,204,21,0.15)]" data-testid="about-guiding-principle">
            <span className="absolute -top-7 -right-3 font-display font-black text-black/10 text-[150px] leading-none select-none">"</span>
            <p className="font-mono-rgp text-[10px] uppercase tracking-[0.3em] text-black/60">Our Guiding Principle</p>
            <p className="mt-4 font-display font-bold uppercase text-2xl lg:text-3xl leading-tight relative">
              Goa's interests and the well-being of its people must remain at the
              heart of every decision.
            </p>
          </div>
        </Reveal>
      </div>

      <div id="agenda" className="mt-24" data-testid="agenda-section">
        <Reveal>
          <div className="flex items-center gap-6">
            <p className="eyebrow whitespace-nowrap">// The Core Platform</p>
            <div className="h-px flex-1 bg-gradient-to-r from-yellow-400/40 to-transparent" />
          </div>
          <div className="mt-6 flex flex-wrap items-end justify-between gap-6">
            <h3 className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-7xl leading-[0.9]">
              11 Core Points<br />
              <span className="text-yellow-400">For a Stronger Goa</span>
            </h3>
            <p className="max-w-sm text-zinc-400 text-sm leading-relaxed pb-2 border-l-2 border-yellow-400/40 pl-4">
              The Revolutionary Goans Party is committed to building a stronger,
              self-reliant and sustainable Goa. The following are our Common Minimum
              Programme priorities, which will form the basis of any possible future
              alliance.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5 auto-rows-fr">
          {POINTS.map((p, i) => (
            <Reveal key={p.title} delay={(i % 3) * 0.08} className="h-full">
              <div className="point-card p-7 flex flex-col" data-testid={`agenda-card-${i + 1}`}>
                <span className="point-num">{String(i + 1).padStart(2, "0")}</span>
                <h4 className="mt-5 font-display font-bold uppercase text-2xl text-white leading-tight">
                  {p.title}
                </h4>
                <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{p.text}</p>
              </div>
            </Reveal>
          ))}

          <Reveal delay={0.16} className="h-full">
            <div className="relative bg-yellow-400 text-black p-7 h-full flex flex-col justify-between overflow-hidden shadow-[0_24px_70px_rgba(250,204,21,0.15)]" data-testid="agenda-vision-card">
              <span className="absolute -bottom-6 -right-2 font-display font-black text-black/10 text-[120px] leading-none select-none">RGP</span>
              <p className="font-mono-rgp text-[10px] uppercase tracking-[0.25em]">Our Vision</p>
              <div>
                <h4 className="font-display font-black uppercase text-2xl leading-tight">
                  "To uphold the rights and dignity of every Goan and build a Goa that is
                  self-reliant, sustainable, prosperous and secure for future generations."
                </h4>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
